<template>
  <div>
    <b-notification :closable="false">
      <div class="columns is-centered is-vcentered">
        <div class="column is-9 is-offset-1">
          <span class="is-title">
            <strong>{{ translate('title') }}</strong>
          </span>
          <br />
          <span v-html="translate('level1help')" />
        </div>
        <div class="column">
          <highcharts :options="options" />
        </div>
      </div>
    </b-notification>
    <b-notification :closable="false">
      <div class="columns is-centered">
        <div class="column is-1">
          <b-icon size="is-large" icon="info" />
        </div>
        <div class="column">
          <span class="is-title">
            <strong>{{ $t('compScenarioRuleCard.context') }}</strong>
          </span>
          <br />
          <span v-html="translate('description')" />
        </div>
      </div>
    </b-notification>
    <template v-if="ngraphics === 1">
      <component :is="rule.graphics[0]" :ghgi="ghgi" :onlyGraphics="true" />
    </template>
    <b-carousel
      v-else-if="ngraphics > 1"
      :indicator="false"
      :autoplay="false"
      icon-pack="fa"
      icon-prev="caret-left"
      icon-next="caret-right"
      icon-size="is-medium"
    >
      <b-carousel-item
        v-for="(name, index) in rule.graphics"
        :key="index"
        :label="translate(name)"
      >
        <component :is="name" :ghgi="ghgi" :onlyGraphics="true" />
      </b-carousel-item>
    </b-carousel>
    <b-table
      v-if="'table' in rule"
      :striped="true"
      :narrowed="true"
      :data="table.data"
      :columns="table.columns"
    />
    <br v-if="ngraphics > 0" />
    <b-notification v-if="translate('otherbenefits')" :closable="false">
      <div class="columns is-centered">
        <div class="column is-1">
          <b-icon size="is-large" icon="plus" />
        </div>
        <div class="column">
          <span class="is-title">
            <strong>{{ $t('compScenarioRuleCard.otherbenefits') }}</strong>
          </span>
          <br />
          <span v-html="translate('otherbenefits')" />
        </div>
      </div>
    </b-notification>
    <b-notification v-if="translate('rebounds')" :closable="false">
      <div class="columns is-centered">
        <div class="column is-1">
          <b-icon size="is-large" icon="bullseye" />
        </div>
        <div class="column">
          <span class="is-title">
            <strong>{{ $t('compScenarioRuleCard.rebounds') }}</strong>
          </span>
          <br />
          <span v-html="translate('rebounds')" />
        </div>
      </div>
    </b-notification>
    <b-notification v-if="translate('limits')" :closable="false">
      <div class="columns is-centered">
        <div class="column is-1">
          <b-icon size="is-large" icon="exclamation" />
        </div>
        <div class="column">
          <span class="is-title">
            <strong>{{ $t('compScenarioRuleCard.limits') }}</strong>
          </span>
          <br />
          <span v-html="translate('limits')" />
        </div>
      </div>
    </b-notification>
    <b-notification v-if="'references' in rule" :closable="false">
      <div class="columns is-centered">
        <div class="column is-1">
          <b-icon size="is-large" icon="question" />
        </div>
        <div class="column">
          <span class="is-title">
            <strong>{{ $t('compScenarioRuleCard.references') }}</strong>
          </span>
          <br />
          <p
            v-for="(reference, index) in Object.keys(rule.references)"
            :key="index"
          >
            {{ reference }} {{ rule.references[reference].authors }}:
            <em>
              <a
                class="link"
                target="_blank"
                :href="rule.references[reference].link"
              >
                {{ rule.references[reference].title }}
              </a> </em
            >. {{ rule.references[reference].year }}.
          </p>
        </div>
      </div>
    </b-notification>
  </div>
</template>

<script>
// import Vue from 'vue'
import '@/plugins/highcharts.js'
import Rule from '@/models/scenario/Rule.js'
import { useCoreStore } from '@/stores/core.js'
import { useScenarioStore } from '@/stores/scenario.js'

export default {
  name: 'RuleCard',
  props: {
    rule: {
      type: Object,
      default: null
    },
    ghgi: {
      type: Object,
      default: null
    }
  },
  components: {
    CarsEmissionFactors: () =>
      import('@/components/graphics/CarsEmissionFactors.vue'),
    CommutesDistancesCarpooling: () =>
      import('@/components/graphics/CommutesDistancesCarpooling.vue'),
    CommutesDistancesModes: () =>
      import('@/components/graphics/CommutesDistancesModes.vue'),
    CommutesEmissionsBar: () =>
      import('@/components/graphics/CommutesEmissionsBar.vue'),
    CommutesNoCommutingDays: () =>
      import('@/components/graphics/CommutesNoCommutingDays.vue'),
    DevicesPie: () => import('@/components/graphics/DevicesPie.vue'),
    DevicesEmissionsFactors: () =>
      import('@/components/graphics/DevicesEmissionsFactors.vue'),
    EnergyPerformance: () =>
      import('@/components/graphics/EnergyPerformance.vue'),
    HeatingEmissionFactors: () =>
      import('@/components/graphics/HeatingEmissionFactors.vue'),
    HeatingPie: () => import('@/components/graphics/HeatingPie.vue'),
    NationalPlanesPie: () =>
      import('@/components/graphics/NationalPlanesPie.vue'),
    PlanesAndTrainsEmissionFactors: () =>
      import('@/components/graphics/PlanesAndTrainsEmissionFactors.vue'),
    PlanesCumulativeEmissions: () =>
      import('@/components/graphics/PlanesCumulativeEmissions.vue'),
    PurchasesPie: () => import('@/components/graphics/PurchasesPie.vue'),
    PurchasesInstrumentsPie: () =>
      import('@/components/graphics/PurchasesInstrumentsPie.vue'),
    PurchasesPieSecondHand: () =>
      import('@/components/graphics/PurchasesPieSecondHand.vue'),
    TransportsEmissionFactors: () =>
      import('@/components/graphics/TransportsEmissionFactors.vue'),
    VehiclesPie: () => import('@/components/graphics/VehiclesPie.vue'),
    FoodsPie: () => import('@/components/graphics/FoodsPie.vue'),
    FoodsEmissionFactors: () =>
      import('@/components/graphics/FoodsEmissionFactors.vue'),
    MealsEmissionFactors: () =>
      import('@/components/graphics/MealsEmissionFactors.vue')
  },
  setup () {
    const coreStore = useCoreStore()
    const scenarioStore = useScenarioStore()
    return { coreStore, scenarioStore }
  },
  computed: {
    options: function () {
      let self = this
      return {
        chart: {
          backgroundColor: '#f5f5f5',
          height: 100,
          margin: [0, 0, 0, 0]
        },
        exporting: {
          enabled: false
        },
        plotOptions: {
          pie: {
            dataLabels: {
              enabled: false
            }
          }
        },
        title: {
          text: this.targetPercentage + '%',
          align: 'center',
          verticalAlign: 'middle',
          y: 16,
          style: {
            fontFamily: 'Ubuntu',
            fontSize: '15px',
            fontWeight: '500'
          }
        },
        tooltip: {
          pointFormatter () {
            return `<b>${self.$options.filters.splitNumberTons(
              this.y
            )} ${self.$t('t.co2e')}</b>`
          }
        },
        series: [
          {
            type: 'pie',
            innerSize: '70%',
            data: [
              {
                name: this.$t('compScenarioRuleCard.tooltip-2'),
                y: this.targetIntensity,
                color: '#80b7ee'
              },
              {
                name: this.$t('compScenarioRuleCard.tooltip-1'),
                y: this.otherIntensity,
                color: '#d6e3f1'
              }
            ]
          }
        ]
      }
    },
    otherIntensity: function () {
      return this.totalIntensity - this.targetIntensity
    },
    totalIntensity: function () {
      return this.ghgi.intensity.intensity
    },
    targetIntensity: function () {
      let targetIntensity = this.rule.getTargetIntensity(
        this.coreStore.setting('commute')
      )
      return targetIntensity.intensity
    },
    targetPercentage: function () {
      return (
        Math.round((this.targetIntensity / this.totalIntensity) * 1000) / 10
      )
    },
    ngraphics: function () {
      let ngraphics = 0
      if ('graphics' in this.rule) {
        ngraphics = this.rule.graphics.length
      }
      return ngraphics
    },
    table: function () {
      let table = { data: {}, columns: {} }
      if ('table' in this.rule) {
        table = this.rule.table(
          this.scenarioStore.item.getData(this.rule.module)
        )
      }
      return table
    }
  },
  methods: {
    translate (key) {
      let translation = Rule.translate(this.rule, key, this.$i18n.locale, true)
      if (translation && 'references' in this.rule) {
        for (let reference of Object.keys(this.rule.references)) {
          translation = translation.replaceAll(
            reference,
            '<a target="_blank" class="link" href="' +
              this.rule.references[reference].link +
              '">' +
              reference +
              '</a>'
          )
        }
      }
      return translation
    } /* ,
    loadComponents () {
      if ('graphics' in this.rule) {
        for (let name of Object.keys(this.rule.graphics)) {
          if (typeof this.rule.graphics[name] === 'string') {
            // Dynamically load the component
            Vue.component(
              this.rule.graphics[name],
              () => import('@/components/graphics/' + this.rule.graphics[name])
            )
          }
        }
      }
    } */
  } /* ,
  watch: {
    'rule.name': function () {
      this.loadComponents()
    }
  },
  mounted () {
    this.loadComponents()
  } */
}
</script>

<style>
.notification a:not(.button):not(.dropdown-item) {
  text-decoration: none !important;
}
.is-title {
  display: inline-block;
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
